<h2 mat-dialog-title>{{ labels.TITLE }}</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="inviteUserForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" class="custom-form-field mt-4">
      <mat-label>{{ labels.EMAIL }}</mat-label>
      <input matInput formControlName="email" type="email">
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.FULL_NAME }}</mat-label>
      <input matInput formControlName="full_name">
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.ROLE }}</mat-label>
      <mat-select formControlName="role">
        @for (role of roleModel.roles; track role) {
          <mat-option [value]="role.value">{{ role.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="custom-form-field">
      <mat-label>{{ labels.TENANT }}</mat-label>
      <mat-select formControlName="tenantId">
        @for (tenant of tenants; track tenant) {
          <mat-option [value]="tenant.id">{{ tenant.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ labels.CANCEL }}</button>
  <button mat-button (click)="onSubmit()" [disabled]="!inviteUserForm.valid" cdkFocusInitial>{{ labels.SAVE }}</button>
</mat-dialog-actions>
